import React from "react";
import { bind } from "decko";

export default class LoginScreen extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            errorMsg: "",
            username: "",
            pwd: ""
        };
    }

    @bind
    handleChangePwd (event) {
        this.setState({pwd: event.target.value});
    }

    @bind
    handleChangeUsr (event) {
        this.setState({username: event.target.value});
    }

    @bind
    login (event) {
        console.log("Login attempt with", this.state.username);
        event.preventDefault();

        if (this.state.username === "" || this.state.pwd === "") {
            this.setState({
                errorMsg: "Please fill in username / password"
            });
            return;
        }

        this.props.server.post("/user/authorize", {
            username: this.state.username,
            password: this.state.pwd
        }, (jsonUser) => {

            if (jsonUser.access_level !== "admin" && jsonUser.access_level !== "super") {
                this.setState({
                    errorMsg: "User account is not an admin user. Please contact administrator to upgrade account"
                });
                return;
            }

            this.props.server.logIn(jsonUser.username, jsonUser.access_token, jsonUser.access_level);
            this.props.onDone();
        }, (error) => {
            console.error("Login failed", error);
            this.setState({
                errorMsg: "Login failed, please try again with different username / password."
            });
        });
    }

    render () {
        return (
            <div className="col-xs-12">
                <h3>
                    Log in to {this.props.server.name}
                </h3>
                {this.state.errorMsg &&
                    <div className="col-xs-12" style={{color: "red"}}>
                        {this.state.errorMsg}
                    </div>
                }
                <div className="col-xs-4 col-xs-offset-4">
                    <div className="col-xs-8 col-xs-offset-2">
                        <form className="form-group" onSubmit={this.login}>
                            <input type="text" className="form-control" placeholder="Username"
                                value={this.state.username} onChange={this.handleChangeUsr} />
                            <input type="password" className="form-control" placeholder="Password"
                                value={this.state.pwd} onChange={this.handleChangePwd} />
                            <input type="submit" className="btn btn-success fullwidth" value="LOG IN" />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/LoginScreen.js